import React, { useState } from 'react'
import { Button, Modal } from "antd"
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { setImportMeta } from 'actions/testAdmin';
import { setFromClassroom } from 'actions/classRoom';
import { setQuickAccessItem } from 'actions/userManagementV2';
import { clearGenerationSnapshot } from '../components/generationCache';

//images
// Using public path directly to avoid Webpack buffer limit errors
const aiTestCard = "/test-assets/ai_test_card.png";
const uploadFileCard = "/test-assets/upload_file_card.png";
const writeOwnCard = "/test-assets/write_own_card.png";
const scanDocCard = "/test-assets/scan_doc_card.png";


const CreateYourOwn = ({ setSelectedType, selectedType, }) => {

    const handleCardClick = () => {
        setSelectedType('createYourOwn')
    }

    return (
        <>
            <div className='flex-column relative cursor-pointer' onClick={handleCardClick}>
                <div className='text-right absolute' style={{ zIndex: 2, padding: 5, }}>
                    {selectedType == 'createYourOwn' ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />}
                </div>
                <img src={writeOwnCard} alt='write_own_card' style={{ width: 250, height: 115, objectFit: 'cover', zIndex: 1, borderRadius: '4px 4px 0 0', border: '1px solid #E6E6E6', borderBottom: 'none' }}></img>
                <div style={{ border: '1px solid #E6E6E6', width: '250px', minHeight: 90, flex: 1, padding: 15, borderRadius: '0 0 4px 4px' }}>
                    <div className='text-xmd bold-700' style={{ color: '#191919' }}>{"Create test manually"}</div>
                    <div className='text-xs bold-600' style={{ color: '#636363' }}>{"Got your own questions? Start with a clean slate."}</div>
                </div>
            </div>
        </>
    )
}

const Import = ({ setSelectedType, selectedType, setImportMeta }) => {

    const handleCardClick = () => {
        setSelectedType('Import')
        setImportMeta("selectedQBType", "sample question papers");
        setImportMeta('selectedTypeId', 1);
    }

    return (
        <>
            <div className='flex-column position-relative cursor-pointer' onClick={handleCardClick}>
                <div className='text-right absolute' style={{ zIndex: 2, padding: 5 }}>
                    {selectedType == 'Import' ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />}
                </div>
                <img src={uploadFileCard} alt='upload_file_card' style={{ width: 250, height: 115, objectFit: 'cover', zIndex: 1, borderRadius: '4px 4px 0 0', border: '1px solid #E6E6E6', borderBottom: 'none' }}></img>
                <div style={{ border: '1px solid #E6E6E6', width: '250px', minHeight: 90, flex: 1, padding: 15, borderRadius: '0 0 4px 4px' }}>
                    <div className='text-xmd bold-700' style={{ color: '#191919' }}>{"Import from aulas Question Bank"}</div>
                    <div className='text-xs bold-600' style={{ color: '#636363' }}>{"Import sample question papers from our collection."}</div>
                </div>
            </div>
        </>
    )
}

const CreateTestType = ({ isModalOpen, closeModal, setImportMeta, fromClassroom, setFromClassroom, setQuickAccessItem }) => {

    const ScanPdf = ({ setSelectedType, selectedType }) => {
        const handleCardClick = () => {
            setSelectedType('ScanPdf')
        }
        return (
            <div className='flex-column position-relative cursor-pointer' onClick={handleCardClick} style={{ marginBottom: 20 }}>
                <div className='text-right absolute' style={{ zIndex: 2, padding: 5 }}>
                    {selectedType == 'ScanPdf' ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />}
                </div>
                <img src={scanDocCard} alt='scan_doc_card' style={{ width: 250, height: 115, objectFit: 'cover', zIndex: 1, borderRadius: '4px 4px 0 0', border: '1px solid #E6E6E6', borderBottom: 'none' }}></img>
                <div style={{ border: '1px solid #E6E6E6', width: '250px', minHeight: 90, flex: 1, padding: 15, borderRadius: '0 0 4px 4px' }}>
                    <div className='text-xmd bold-700' style={{ color: '#191919' }}>{"Extract questions from PDF"}</div>
                    <div className='text-xs bold-600' style={{ color: '#636363' }}>{"Scan your physical papers"}</div>
                </div>
            </div>
        )
    }

    const GenerateAulasAi = ({ setSelectedType, selectedType }) => {
        const handleCardClick = () => {
            setSelectedType('GenerateAulasAi')
        }
        return (
            <div className='flex-column position-relative cursor-pointer' onClick={handleCardClick} style={{ marginBottom: 20 }}>
                <div className='text-right absolute' style={{ zIndex: 2, padding: 5 }}>
                    {selectedType == 'GenerateAulasAi' ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />}
                </div>
                <img src={aiTestCard} alt='ai_test_card' style={{ width: 250, height: 115, objectFit: 'cover', zIndex: 1, borderRadius: '4px 4px 0 0', border: '1px solid #E6E6E6', borderBottom: 'none' }}></img>
                <div style={{ border: '1px solid #E6E6E6', width: '250px', minHeight: 90, flex: 1, padding: 15, borderRadius: '0 0 4px 4px' }}>
                    <div className='text-xmd bold-700' style={{ color: '#191919' }}>{"Generate with aulasAi"}</div>
                    <div className='text-xs bold-600' style={{ color: '#636363' }}>{"Let AI create questions for you"}</div>
                </div>
            </div>
        )
    }

    //HOISTINGS
    const history = useHistory();

    //USESTATES
    const [selectedType, setSelectedType] = useState('')
    // HANDLERS
    const handleNextClick = () => {
        setQuickAccessItem({})
        if (selectedType == 'createYourOwn') {
            setFromClassroom(false)
            if (fromClassroom) {
                setFromClassroom(true)
                history.push({ pathname: '/create-test', state: { key: "fromClassroom" } });
            } else {
                history.push('/create-test')
            }
        } else if (selectedType == 'GenerateAulasAi') {
            // A fresh start, not a return from /create-test.
            clearGenerationSnapshot()
            setFromClassroom(false)
            if (fromClassroom) {
                setFromClassroom(true)
                history.push({ pathname: '/generate-test-aulas-ai', state: { key: "fromClassroom" } });
            } else {
                history.push('/generate-test-aulas-ai')
            }
        } else if (selectedType == 'ScanPdf') {
            setFromClassroom(false)
            if (fromClassroom) {
                setFromClassroom(true)
                history.push({ pathname: '/scan-pdf-test', state: { key: "fromClassroom" } });
            } else {
                history.push('/scan-pdf-test')
            }
        } else {
            setFromClassroom(false)
            if (fromClassroom) {
                setFromClassroom(true)
                history.push({ pathname: '/test-import-classes', state: { key: "fromClassroom" } });
            } else {
                history.push('/test-import-classes')
            }
        }
    }



    return (
        <div>
            <Modal
                centered
                visible={isModalOpen}
                footer={null}
                className='modal-round-corner'
                style={{ padding: 0, width: '100%' }}
                onCancel={closeModal}
                onOk={null}
                width={580}
                closable={true}
            >
                <div style={{ textAlign: "center", fontSize: "21px", color: "#191919", fontWeight: "bold" }}>Choose</div>
                <>
                    <div style={{ width: '100%', marginTop: "20px", display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
                        <CreateYourOwn setSelectedType={setSelectedType} selectedType={selectedType} />
                        <Import setSelectedType={setSelectedType} selectedType={selectedType} setImportMeta={setImportMeta} />
                        <ScanPdf setSelectedType={setSelectedType} selectedType={selectedType} />
                        <GenerateAulasAi setSelectedType={setSelectedType} selectedType={selectedType} />
                    </div>
                    <center className='r-jsb m-t-20' style={{ width: '60%', display: 'flex', justifyContent: 'space-between', marginLeft: 95 }}>
                        <Button className='radius-100' style={{ width: 120 }} onClick={() => { closeModal() }} >CANCEL</Button>
                        <Button className='purpleBtnWrap radius-100 purpleButtonHoverEffect' onClick={handleNextClick} disabled={selectedType === "" ? true : false}>NEXT</Button>
                    </center>
                </>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
    };
}

const mapDispatchToProps = (dispatch) => ({
    setImportMeta: (key, val) => dispatch(setImportMeta(key, val)),
    setFromClassroom: (val) => dispatch(setFromClassroom(val)),
    setQuickAccessItem: (res) => dispatch(setQuickAccessItem(res))
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateTestType)

// export default CreateTestType